import React, { useState, useEffect } from 'react'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import ProjectBudgetReportWidget from '../../widgets/ProjectBudgetReportWidgets/ProjectBudgetReportWidget'
import TopLevelNav from '../../components/TopLevelNav'
import {
  getDashboardProjectBudgetReport,
  getSubProjectCounterSummaryDetail,
} from '../../redux/actions/dashboard'
import PageToolbar from '../../components/PageToolbar'
import { isEmpty } from 'lodash-es'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import SubProjectListSatusReportWidget from '../../widgets/dashboard/subproject/SubProjectListSatusReportWidget'
import ContentHeaderWidget from '../../components/ContentHeader/ContentHeaderWidget'

export default function ProjectListStatusReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  // const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // let req = sessionStorage.getItem('up-down-strem-req')
      let key = sessionStorage.getItem('up-down-strem-key')
      let masterKey = sessionStorage.getItem('up-down-strem-master-key')

      if (isEmpty(key) && isEmpty(masterKey)) {
        setError({
          statusCode: 404,
          errorMessage: 'ไม่พบสถานะติดตามที่ต้องการแสดง กรุณาดำเนินการผ่านหน้าหลัก',
        })
      } else {
        let req = {
          masterKey: masterKey,
          key: key,
        }
        const response = await getSubProjectCounterSummaryDetail(req)
        //console.log('ressponse => ', response)
        if (response?.model) {
          setSchema(response?.model)
        } else {
          setError({
            statusCode: 500,
            errorMessage: response?.errorMessage || DEFAULT_ERR_MSG,
          })
        }
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </div>
    )
  }

  if (!schema || isLoading) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <PanalLoadingTemplate />
        <OverlayLoader />
      </div>
    )
  }

  return (
    <>
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <ContentHeaderWidget header={schema.header || ''} subHeader={schema.subHeader || ''} />
        <SubProjectListSatusReportWidget schema={schema} />
      </div>
    </>
  )
}
